<div class="row">
    <div class="col-12 pl-0 pl-md-3 pr-0 pr-md-3">
        <r247-number-chooser (numberConfirmed)="goToRegister($event)"></r247-number-chooser>
    </div>
</div>
